import { Types } from "./types";

const initialState = {
  dataTap: {
    paging: {},
    dataTap: {},
    tonAddress: {},
  },
  dataFarm: {
    paging: {},
    dataTap: {},
    tonAddress: {},
  },
};
const configReducer = (state = initialState, action) => {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case Types.SAVE_LIST_TAP:
      return {
        ...newState,
        dataTap: action.payload,
      };
    case Types.SAVE_LIST_FARM_CONFIG:
      return {
        ...newState,
        dataFarm: action.payload,
      };
    case Types.SAVE_TON_ADDRESS:
      return {
        ...newState,
        tonAddress: action.payload,
      };
    default:
      return { ...newState };
  }
};
export default configReducer;
